import request from "@/util/request.js";

export const getArticleInfo = ({ id }) =>
  request({
    url: `/admin/rich/text/getContentById/${id}`,
    method: "GET",
  });
